<template>
  <div class="select_dropdown" :class="{ disabled }">
    <div v-if="optionsIsOpen" class="resetDate" @click="closeOptions" />
    <div class="dropdown-menu ripple" @click="openOptions()">
      {{ dateSelected }}
      <i v-if="settings.dateOptions.startTime || settings.dateOptions.endTime"
         class="icone material-icons"
      >
        access_time
      </i>
    </div>

    <div v-if="optionsIsOpen" class="options">
      <h1>Selecione o dia</h1>

      <div v-for="d in marketDays" :key="d.id"
           class="days" :class="{'selected': d.id === day}"
           @click="changeDay(d.id)"
      >
        {{ d.name }}
      </div>

      <h1>Selecione o horário</h1>

      <div class="time">
        <div class="item">
          <i class="icone material-icons">
            access_time
          </i>
          <input v-model="startTime" type="time" @focus="closeValidation()">
        </div>

        <div class="item">
          <i class="icone material-icons">
            watch_later
          </i>
          <input v-model="endTime" type="time" @focus="closeValidation()">
        </div>
      </div>


      <div class="button">
        <div class="feedback" :class="cssFeedBack">
          {{ errorAfter
            ? 'Por favor, escolha um horário de até 5 minutos antes dos minutos registrados :)'
            : 'Por favor, informe um horário de término maior que o de início :)'
          }}
        </div>
        <button class="btn btn_full btn_primary" @click="applyChanges()">
          Aplicar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import moment from 'moment';

export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showOptions: false,
      optionsIsOpen: false,
      day: 1,
      startTime: '',
      endTime: '',
      feedBackOpen: null,
      errorAfter: false, 
    };
  },
  computed: {
    ...mapState(['settings']),
    ...mapGetters(['marketDays']),
    dateSelected() {
      const { day } = this.settings.dateOptions;
      if (this.marketDays[day]) {
        const { name } = this.marketDays[day];
        return name;
      }
      return '--';
    },
    cssFeedBack() {
      return {
        'feedback--show': this.feedBackOpen === true,
        'feedback--hide': this.feedBackOpen === false,
      };
    },
  },
  methods: {
    openOptions() {
      this.optionsIsOpen = true;
    },
    closeOptions() {
      this.optionsIsOpen = false;
    },
    closeValidation() {
      if (this.feedBackOpen) {
        this.feedBackOpen = false;
        setTimeout(() => {
          this.feedBackOpen = null;
        }, 1000);
      }
    },
    openValidation() {
      this.feedBackOpen = true;
    },
    animateValidationBox() {
      // Show the validation box -> start gradient animation -> close
      this.openValidation();
      clearTimeout(this.timerToHideValidation);
      this.isValidationShow = true;
      setTimeout(() => {
        this.isValidationShow = false;
        this.timerToHideValidation = setTimeout(() => {
          this.closeValidation();
        }, 3000);
      }, 750);
    },
    changeDay(day) {
      this.day = day;
      this.startTime = '';
      this.endTime = '';
    },
    applyChanges() {
      this.errorAfter = false;
      const selectedDate = moment().subtract(this.day, 'days');
      [this.startTime, this.endTime].forEach((time) => {
        if (!time) return;
        const [hours, minutes] = time.split(':');
        const date = selectedDate.clone().set({ hours, minutes }).add(5, 'minutes');
        if (moment().isBefore(date)) {
          this.errorAfter = true;
        }
      });

      if ((this.endTime && this.endTime < this.startTime) || this.errorAfter) {
        this.animateValidationBox();
        return;
      }
      this.closeOptions();
      this.$store.dispatch('selectDate', { day: this.day, startTime: this.startTime, endTime: this.endTime });
    },
  },
};
</script>

<style lang="scss" scoped>

@import '@/assets/scss/variables.scss';

  .resetDate {
    width: 100vw;
    height: 100vh;
    position: fixed;
    z-index: 5;
    top: 0;
    left: 0;
  }

  // Select
    .select_dropdown {
      position: relative;
      height: 40px;
      box-shadow: 0 4px 24px rgba($color-gray-darker, 0.08);

      // DISABLED
      &.disabled {
        pointer-events: none;
        background-color: #CCCCCC;
        opacity: 0.2;
      }
      // ---------------------------

      .dropdown-menu {
        display: flex;
        flex-wrap: wrap;
        align-content: center;
        height: 100%;
        padding: 12px 16px;
        width: 216px;
        border-radius: 4px;

        font-family: $primary-typo;
        font-weight: 500;
        font-size: 0.64em;
        color: $color-gray-dark;
        cursor: pointer;
        background-position: center;
        background: $color-gray-lighter;
        transition: background 0.4s ease-in-out, color 0.4s ease-in-out;

        &:hover {
          background: $color-gray-lighter radial-gradient(circle, transparent 1%, $color-gray-lighter 1%) center/15000%;
          color: $color-secondary;
        }

        &:active {
          background-color: rgba($color-gray-light, 0.48);
          background-size: 100%;
          transition: background 0s;
        }

        i {
          font-size: 1.8em;
          margin: -2px 0 0 8px;
          opacity: 0.4;
        }
      }
      // Fim do Dropdown-Menu

      .options {
        position: absolute;
        top: 48px;
        left: 0;
        z-index: 6;
        width: 324px;
        box-sizing: border-box;
        background-color: $color-gray-lighter;
        border-radius: 4px;
        box-shadow: 0 24px 80px rgba($color-gray-darker, 0.4);
        animation: fadeIn 0.4s ease-in-out forwards;

        // Títulos
        h1 {
          width: 100%;
          box-sizing: border-box;
          padding: 16px 16px 0 16px;
          font-family: $secondary-typo;
          font-weight: 500;
          font-size: 0.64em;
          font-style: italic;
          color: $color-gray-darker;
          text-transform: uppercase;

          &::after {
            content: "";
            width: 16px;
            height: 2px;
            display: block;
            margin: 4px 0 0 0;
            background: rgba($color-gray-light, 0.64);
          }
        }

        .days {
          padding: 16px;
          display: flex;
          justify-content: space-between;
          font-family: $secondary-typo;
          font-weight: 400;
          font-size: 0.8em;
          color: $color-gray-main;
          border-bottom: solid 2px $color-gray-back;
          background-position: center;
          transition: background 0.4s ease-in-out, border-bottom 0.4s ease-in-out, color 0.4s ease-in-out;
          cursor: pointer;

          &:hover {
            background: $color-gray-back radial-gradient(circle, transparent 1%, $color-gray-back 1%) center/15000%;
            border-bottom: solid 2px $color-gray-light;
            color: $color-gray-dark;
          }

          &:active {
            background-color: rgba($color-gray-light, 0.48);
            background-size: 100%;
            transition: background 0s;
          }

          &.selected {
            font-weight: 600;
            color: $color-secondary;
          }
        }

        .time {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          padding: 16px;

          .item {
            position: relative;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            align-items: center;
            width: 48%;

            i {
              position: absolute;
              font-size: 1em;
              color: $color-gray-main;
              left: 8px;
            }

            input {
              width: 100%;
              background: $color-gray-lighter;
              box-shadow: 0 2px 16px rgba($color-gray-darker, 0.16);
              border: none;
              border-radius: 4px;
              padding: 12px 8px 12px 32px;
              font-family: $secondary-typo;
              font-size: 0.88em;
            }

          }
        }

        .button {
          position: relative;
          width: 100%;

          .btn {
            border-radius: 0 0 4px 4px;
          }

          // Feedback
          .feedback {
            display: flex;
            align-items: center;
            border-radius: 0 0 4px 4px;
            text-align: center;
            font-size: 0.8em;
            height: 56px;
            padding: 0 24px;
          }
        }
      }
      // Fim do options

      &:after {
        content: " ";
        position: absolute;
        top: 50%;
        margin-top: -2px;
        right: 16px;
        width: 0;
        height: 0;
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;
        border-top: 4px solid $color-gray-main;
        pointer-events: none;
      }
    }
    // Fim do Select --------------

    // Validation
    .feedback {
      position: absolute;
      bottom: 0;
      z-index: 4;
      width: 100%;
      height: 64px;
      opacity: 0;
      pointer-events: none;
      box-sizing: border-box;
      padding: 16px 14px;

      font-family: $secondary-typo;
      font-size: 0.8em;
      font-weight: 500;
      line-height: 1.4em;
      color: rgba($color-gray-lighter, 1);
      border-radius: 4px;

      background: linear-gradient(233deg, #630d58, #a8203c);
      background-size: 100% 100%;

        // Show
        &.feedback--show {
          opacity: 0;
          animation: fadeInUp 0.8s ease-in-out forwards;
        }

        // Hide
        &.feedback--hide {
          opacity: 1;
          animation: fadeOutDown 0.8s ease-in-out forwards;
        }
    }

    // Second Break : 850px
    @media (max-width: 850px) {

      .header {
        .box {
          .navigation {

              // Select
              .select_dropdown {

                .dropdown-menu {
                  padding: 14px 8px 12px 8px;
                  width: 156px;
                  font-size: 0.56em;

                  i {
                    font-size: 1.6em;
                    margin: -1px 0 0 8px;
                  }
                }
                // Fim do Dropdown-Menu

                .options {
                  left: inherit;
                  right: 0;
                }
                // Fim do options
              }
              // Fim do Select --------------
          }
        }
      }
    }

</style>
